// service name
import { toLower } from 'lodash';

export const NOONA = 'Noona';

// eligible to use noona
export const PYYDETTY = 'pyydetty';

// patient has requested integration between noona and omatays
export const SUOSTUMUS = 'suostumus';

// patient currently uses integration between noona and omatays
export const KAYTTAJA = 'käyttäjä';

// patient has stopped using integration between noona and omatays
export const LUKITTU = 'lukittu';

export const compareStatus = (status1, status2) => {
  return toLower(status1) === toLower(status2);
};

export default {
  NOONA,
  PYYDETTY,
  SUOSTUMUS,
  KAYTTAJA,
  LUKITTU,
};
